import { css } from 'glamor'

export default {
  welcomeWrapper: css({
    display: 'flex',
    alignItems: 'flex-start',

    '@media (min-width: 700px)': {
      height: '100%',
      alignItems: 'center',
    },
  }),
  welcome: css({

    '@media (min-width: 700px)': {
      height: '470px',
      padding: '15px',
    },
  }),
  logoWrapper: css({
    textAlign: 'center',
  }),
  logo: css({
    maxHeight: '135px',

    '@media (min-width: 700px)': {
      marginBottom: '30px',
    },
  }),
  content: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    lineHeight: '1.4',

    '@media (min-width: 700px)': {
      height: 'calc(100% - 200px)',
    },
  }),
  texts: css({
  }),
  title: css({
    fontSize: '26px',
    textAlign: 'center',
    margin: '20px 0',

    '@media (min-width: 700px)': {
      margin: '0',
      marginBottom: '30px',
    },
  }),
  description: css({
    fontSize: '16px',
    textAlign: 'center',

    marginBottom: '20px',

    '@media (min-width: 700px)': {
      margin: '0',
    },
  }),
  footer: css({
    textAlign: 'center',
  }),
  controls: css({
    textAlign: 'center',

    '@media(min-width: 700px)': {
      marginBottom: '12px',
    },
  }),
}




// WEBPACK FOOTER //
// ./src/components/Welcome/styles.js